import type { SpinResponse } from "@slot/client-engine";
import { SECRET_BONUS_OFFER_ID } from "../../../features/secret-bonus/secretBonusOffer";
import { MergeRoundBuilder } from "../../MergeRoundBuilder";
import { OFFLINE_ROUND } from "../offlineRound";
import { SECRET_BONUS_SPIN_SCRIPTS } from "./freeSpinScripts";

/**
 * The Secret Bonus bought (decision 51): the reveal lands three FS on a dead board, then the twelve free spins — more
 * than the Bonus Buy's eight. Pays 33.10.
 */
export function fsSecretBonus(): SpinResponse {
  return new MergeRoundBuilder({ roundId: "merge-secret-bonus-buy", ...OFFLINE_ROUND })
    .baseSpin(
      {
        board: [
          ["L2", "H1", "L3", "L1", "H3", "L4"],
          ["L4", "FS", "H2", "L3", "L2", "H1"],
          ["H4", "L3", "L1", "L4", "FS", "L2"],
          ["L1", "L2", "H3", "L2", "L3", "L1"],
          ["H2", "L4", "FS", "H4", "L1", "H2"],
          ["L3", "H1", "L2", "L1", "L4", "L3"],
        ],
        refill: [[], [], [], [], [], []],
      },
      { freeSpins: { featureIdentifier: SECRET_BONUS_OFFER_ID, spins: SECRET_BONUS_SPIN_SCRIPTS } },
    )
    .build();
}
